import { Component, h, Prop } from '@stencil/core'
import { dayjs } from 'src/lib/dayjs'

import { InertiaLink } from '../../../../inertia/link/link'
import { CallStore, IRelatedCall } from '../state'

@Component({ tag: 'page-call-detail-related-call' })
export class RelatedCall {
  @Prop() call: IRelatedCall

  get isBefore() {
    return (
      CallStore.state?.call?.recording &&
      dayjs(this.call.recording_started_at).isBefore(CallStore.state.call.recording.started_at)
    )
  }

  render() {
    return (
      <InertiaLink href={this.call.detail_url} class={`spacing-x-1 flex items-center truncate tracking-tight text-md`}>
        <ui-icon size='3xl' class='text-brand' icon='fathom'></ui-icon>
        <dl class='flex flex-col flex-grow pl-1'>
          <dt class='font-bold'>{this.call.title}</dt>
          <dd class='text-xs text-glyph-lighter'>
            <span class='font-extrabold'>{this.isBefore ? 'Previous' : 'Most Recent'} Meeting</span>
            <span class='font-medium'>
              &nbsp;&bull;&nbsp;
              {dayjs(this.call.recording_started_at).format('MMMM D, YYYY')}
            </span>
          </dd>
        </dl>
      </InertiaLink>
    )
  }
}
